import React, { useState, useEffect } from 'react';
import { Container } from 'reactstrap';
import EventNewCard from './Card/EventNewCard';
import Amplify, { Auth } from 'aws-amplify';
import config from '../aws-exports';
import Lottie from 'react-lottie';
import { default as animationData } from '../assets/loader.json';
import { useLocation } from 'react-router';
import { cx } from '@emotion/css';
import * as styles from './welcome/welcome.style';
import * as assignmentStyles from './assignments/assignments.style';
import eventHeroImg from '../assets/gen_images/eventicon.png';
import { withAuthenticator } from 'aws-amplify-react';
import { get } from 'lodash';

Amplify.configure(config);

function EventsScreen(props) {
  const [events, set_events] = useState([]);
  const [loadedevents, set_loadedevents] = useState(false);
  const data1 = useLocation();

  useEffect(() => {
    getToken();
    const category = get(data1, 'state.category', 'Events');
    document.title = `${category} | QuizWizard`;
  }, [data1]);

  const getToken = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const res = await Auth.currentSession();
      const jwt = res.getAccessToken().getJwtToken();
      const username = user.username.includes("Google_") ? user.attributes['email'] : user.username;
      getEventsfromDB(username, jwt);
    } catch (error) {
      console.error("Auth error:", error);
      Auth.signOut();
    }
  };

  const getEventsfromDB = async (username, jwt) => {
    const category = get(data1, 'state.category', 'General Knowledge');
    const categoryreplace = category.replace(/%20/g, ' ');

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      body: JSON.stringify({
        username: username,
        category: categoryreplace,
        eventtype: 'Event',
      }),
    };

    try {
      const response = await fetch(`https://api.quizwizard.net/quiz/getallevents`, requestOptions);
      const data = await response.json();
      
      let loopData = [];
      data.forEach(item => {
        if (item.events) {
          loopData.push(...item.events);
        }
      });

      set_events(loopData);
      set_loadedevents(true);
    } catch (error) {
      console.error("Error fetching events:", error);
      set_loadedevents(true);
    }
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: { preserveAspectRatio: 'xMidYMid slice' },
  };

  const currentCategory = get(data1, 'state.category', 'Sports');

  return (
    <div className={cx(styles.pageWrapper)}>


      <Container>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '1rem', marginBottom: '3rem' }}>
          <h2 className={cx(assignmentStyles.sectionHeading)} style={{ margin: 0 }}>
            Active {currentCategory} Events
          </h2>
          {loadedevents && events.length > 0 && (
            <span style={{ 
              background: 'rgba(0, 200, 0, 0.1)', 
              color: '#00c800', 
              padding: '4px 12px', 
              borderRadius: '999px', 
              fontSize: '0.85rem', 
              fontWeight: '700',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              border: '1px solid rgba(0, 200, 0, 0.2)'
            }}>
              <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#00c800', display: 'inline-block' }}></span>
              {events.length} LIVE NOW
            </span>
          )}
        </div>

        {loadedevents ? (
          events.length > 0 ? (
            <div className={cx(assignmentStyles.challengeGrid)}>
              {events.map((event) => (
                <EventNewCard
                  key={event.id}
                  title={event.name}
                  imgsrc={'https://api.quizwizard.net/assets/' + encodeURIComponent(event.name) + '.png'}
                  levels={event.levels}
                  totalquestions={event.totalquestions}
                  event={event}
                />
              ))}
            </div>
          ) : (
            <div style={{ 
              textAlign: 'center', 
              padding: '4rem 2rem', 
              background: 'rgba(0,0,0,0.02)', 
              borderRadius: '2rem',
              border: '2px dashed rgba(0,0,0,0.05)'
            }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📅</div>
              <h3 style={{ fontWeight: '700', color: 'hsl(240, 15%, 15%)' }}>No Active Events</h3>
              <p style={{ color: 'hsl(240, 5%, 40%)' }}>There are currently no live events for this category. Please check back soon!</p>
            </div>
          )
        ) : (
          <div className="text-center py-5">
            <Lottie options={defaultOptions} height={200} width={200} />
            <p className="mt-3">Loading events...</p>
          </div>
        )}
      </Container>
    </div>
  );
}

export default withAuthenticator(EventsScreen, false);
